import Domain from "./domain";
export default {
  methods: {
    getAdminsDetails: async function() {
      // get admins list
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "accounts/list",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    listUserByAdmin: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "admin/company/users",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    createUserByAdmin: async function(obj) {
      /*
        {
          "first_name": "nuwan",
          "last_name":"kumara",
          "username": "dad",
          "mobile": "413",
          "email": "sad@gmail.com",
          "role": 2,
          "company": "5def8a69056e9017b628260f",
          "permissions":["cfv"],
          "password": "123456"
        }
      */
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "admin/company/users",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    updateUserByAdmin: async function(obj) {
      /*
         {
            "role": 1,
            "alrady_loged": 0,
            "permissions": [
                "cfv"
            ],
            "_id": "5def8a69056e9017b6282610",
            "first_name": "ssstest",
            "last_name": "ssstest",
            "username": "sss_934153",
            "mobile": "+947765571356",
            "email": "abc@edpass.com",
            "company": "5def8a69056e9017b628260f",
            "created_date": "2019-12-10T12:07:05.930Z",
            "updated_date": "2020-02-13T05:44:25.199Z"
        }
      */
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "admin/company/users",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    adminLogin: async function(obj, id) {
      let dom = Domain.RAW_DOMAIN;
      if (id) {
        dom = dom + "/" + id;
      }
      try {
        let response = await this.axios.post(
          dom + "/api/v1/customer/auth/login",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postAdmin: async function(obj) {
      // post admin
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "auth/register/admin",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putAdmin: async function(obj) {
      // put admin
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "accounts",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteAdmin: async function(id) {
      // delete admin
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "accounts/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
